import React from "react";
import { CheckCircle, Clock, FileText } from "lucide-react";

const ProgressSteps: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-8 mb-8">
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-8 px-2">
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center mb-2">
              <CheckCircle size={20} />
            </div>
            <span className="text-sm font-medium text-gray-900">
              Information Submitted
            </span>
          </div>
          <div className="flex-1 h-0.5 bg-primary mx-6"></div>
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center mb-2">
              <Clock size={20} />
            </div>
            <span className="text-sm font-medium text-gray-900">
              Monitoring Rates
            </span>
          </div>
          <div className="flex-1 h-0.5 bg-gray-200 mx-6"></div>
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 rounded-full bg-gray-200 text-gray-400 flex items-center justify-center mb-2">
              <FileText size={20} />
            </div>
            <span className="text-sm font-medium text-gray-500">
              Refinance Opportunity
            </span>
          </div>
        </div>

        <div className="bg-primary-light/10 p-6 rounded-md mb-8">
          <h4 className="text-lg font-medium text-primary mb-4">
            How Refi Buddy Works
          </h4>
          <ul className="space-y-3 text-primary">
            <li className="flex items-start">
              <CheckCircle size={18} className="mr-2 mt-1 flex-shrink-0" />
              <span>
                Our system automatically checks current market rates and
                compares them to your mortgage.
              </span>
            </li>

            <li className="flex items-start">
              <CheckCircle size={18} className="mr-2 mt-1 flex-shrink-0" />
              <span>A loan officer will provide refinancing options.</span>
            </li>
            <li className="flex items-start">
              <CheckCircle size={18} className="mr-2 mt-1 flex-shrink-0" />
              <span>
                You'll get notified when it's a good time to refinance.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ProgressSteps;
